import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./footer.css";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="footerContact">
        <div className="container">
          <div className="send flex">
            <div className="text">
              <h1>{t("footer_questions_title")}</h1>
              <p>{t("footer_questions_sub")}</p>
            </div>

            <button className="btn5">
              <a style={{ textDecoration: "none" }} href="/contact">
                {t("footer_contact_btn")}
              </a>
            </button>
          </div>
        </div>
      </section>

      <footer>
        <div className="container">
          {/* About Section */}
          <div className="box">
            <div className="logo">
              <h2>{t("footer_about_title")}</h2>
              <p>{t("footer_about_desc")}</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="box">
            <h3>{t("footer_quick_links")}</h3>
            <ul>
              <li>
                <a className="hoverclass" href="/">
                  {t("footer_home")}
                </a>
              </li>
              <li>
                <a className="hoverclass" href="/about">
                  {t("footer_about")}
                </a>
              </li>
              <li>
                <a className="hoverclass" href="/services">
                  {t("footer_services")}
                </a>
              </li>
              <li>
                <a className="hoverclass" href="/contact">
                  {t("footer_contact")}
                </a>
              </li>
            </ul>
          </div>

          {/* Useful Links */}
          <div className="box">
            <h3>{t("footer_useful_links")}</h3>
            <ul>
              <li>
                <a className="hoverclass" href="/privacy">
                  {t("footer_privacy")}
                </a>
              </li>
              <li>
                <a className="hoverclass" href="/disclaimer">
                  {t("footer_disclaimer")}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="box">
            <h3>{t("footer_contact_title")}</h3>

            <div className="servicelink1">
              <span className="fa fa-map-marker bulletlist111"></span>
              <span>{t("footer_address")}</span>
            </div>

            <div className="servicelink1">
              <span className="fa fa-phone bulletlist111"></span>
              <span>{t("footer_phone")}</span>
            </div>

            <div className="servicelink1">
              <span className="fa fa-envelope bulletlist111"></span>
              <span>{t("footer_email1")}</span>
            </div>

            <div className="servicelink1">
              <span className="fa fa-envelope bulletlist111"></span>
              <span>{t("footer_email2")}</span>
            </div>

            <div className="servicelink1">
              <span className="fa fa-globe bulletlist111"></span>
              <span>{t("footer_website")}</span>
            </div>
          </div>
        </div>
      </footer>

      <div className="legal">
        <span>{t("footer_copyright")}</span>
      </div>
    </>
  );
};

export default Footer;
